/** Hindi: सहेजे गए पते और अभी की जगह (ADR 0045)। */
export const address = {
    "addr.title": "सहेजे गए पते",
    "addr.add": "पता जोड़ें",
    "addr.none": "अभी कोई पता सहेजा नहीं है।",
    "addr.private": "सौदा पक्का होने तक कामगारों को सिर्फ़ आपका इलाक़ा दिखेगा। पूरा पता सिर्फ़ उसी कामगार को जाएगा जिससे सौदा पक्का होगा।",
    "addr.use_location": "मेरी अभी की जगह इस्तेमाल करें",
    "addr.why_title": "अपनी जगह इस्तेमाल करें?",
    "addr.why": "GigSync आपके फ़ोन से एक बार पूछता है कि आप कहाँ हैं, ताकि इलाक़ा, शहर और पिन कोड भर सके। आपके फ़ोन से सिर्फ़ लगभग एक किलोमीटर का मोटा अंदाज़ा बाहर जाता है, और सौदे से पहले कामगारों को सिर्फ़ आपका इलाक़ा दिखता है।",
    "addr.allow": "आगे बढ़ें",
    "addr.not_now": "अभी नहीं",
    "addr.locating": "आपका इलाक़ा ढूँढ रहे हैं…",
    "addr.denied": "GigSync के लिए लोकेशन बंद है। पता खोजें या लिख दें।",
    "addr.failed": "आपका इलाक़ा नहीं मिला। खोजें या लिख दें।",
    "addr.found": "आप {area} में हैं। जानकारी देख लें और मकान या फ़्लैट नंबर जोड़ें।",
    "addr.search": "अपना इलाक़ा या इमारत खोजें",
    "addr.find": "खोजें",
    "addr.search_none": "कुछ नहीं मिला। नीचे पता लिख दें।",
    "addr.search_off": "खोज अभी उपलब्ध नहीं है। नीचे पता लिख दें।",
    "addr.house": "मकान या फ़्लैट नंबर",
    "addr.floor": "मंज़िल (ज़रूरी नहीं)",
    "addr.building": "इमारत या सोसाइटी (ज़रूरी नहीं)",
    "addr.street": "गली (ज़रूरी नहीं)",
    "addr.landmark": "पास की पहचान (ज़रूरी नहीं)",
    "addr.area": "इलाक़ा",
    "addr.city": "शहर",
    "addr.pin": "पिन कोड",
    "addr.label": "इस नाम से सहेजें",
    "addr.label.home": "घर",
    "addr.label.work": "दफ़्तर",
    "addr.label.other": "दूसरा",
    "addr.save": "पता सहेजें",
    "addr.check_pin": "क्या पिन आपके दरवाज़े पर है? नक्शा खिसकाकर उसे दरवाज़े पर लाएँ, फिर पता सहेजें दबाएँ।",
    "addr.cancel": "रद्द करें",
    "addr.err_pin": "पिन कोड छह अंकों का होता है।",
    "addr.err_missing": "मकान या फ़्लैट नंबर, इलाक़ा, शहर और पिन कोड भरें।",
    "addr.near": "GigSync यह पता नक्शे पर नहीं ढूँढ पाया। यह इनमें से किस इलाक़े के सबसे पास है?",
    "addr.remove": "हटाएँ",
    "addr.not_served": "माफ़ कीजिए! हम अभी आपके इलाके में नहीं हैं, पर इस पर काम कर रहे हैं।",
    "addr.desk": "आपके पते। किसी पर टैप करके उसे चुनें, या नया पता जोड़ें।",
    "addr.desk_none": "अभी कोई पता सेव नहीं है। एक जोड़ें, या अभी जहाँ हैं वहाँ का इस्तेमाल करें।",
    "addr.new": "नया पता जोड़ें",
    "addr.using": "चुना गया: {label}, {area}",
    "addr.header": "चुना गया पता: {label}, {area}। बदलने के लिए टैप करें।",
    "addr.header_none": "अपना पता जोड़ें",
    "addr.done": "हो गया",
    "map.move_pin": "नक्शा खिसकाकर पिन को दरवाज़े पर लाएँ",
    "map.of": "{place} का नक्शा",
    "map.directions": "रास्ता देखें",
    "addr.chip": "{label} · {area}",
    "addr.max": "आप ज़्यादा से ज़्यादा {max} पते रख सकते हैं। नया जोड़ने के लिए एक हटाएँ।",
    "need.ask.address": "काम कहाँ करवाना है?",
    "need.ask.address_in": "{area} में वर्कर किस पते पर आए?",
    "card.area_choose": "अपना इलाका चुनें",
    "card.use_location": "मेरे इलाक़े के लिए मेरी जगह इस्तेमाल करें",
    "card.area_found": "आपका इलाक़ा: {area}",
};
//# sourceMappingURL=address.js.map